export const MAXPARTIDAS = 5;
export const CAMBIONIVELBASE = 6;
export const NIVELINICIAL = 6;
